import * as queries from './queries';

export const orderPreparatoryConfig = {
  queries: {
    ...queries
  }
};
